import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SecretsStateType, SecretToken } from 'types/secrets';

const defaultState: SecretsStateType = {
  isFetching: false,
  tokens: [],
};

type SecretsReducers = {
  secretsFetchStartedAction: CaseReducer<SecretsStateType>;
  secretsGenerateStartedAction: CaseReducer<SecretsStateType>;
  secretsRevokeStartedAction: CaseReducer<SecretsStateType>;
  secretsFetchedAction: CaseReducer<
    SecretsStateType,
    PayloadAction<SecretToken[]>
  >;
  secretsGeneratedAction: CaseReducer<
    SecretsStateType,
    PayloadAction<SecretToken>
  >;
  secretsRevokedAction: CaseReducer<
    SecretsStateType,
    PayloadAction<SecretToken['id']>
  >;
  secretsVisibilityToggledAction: CaseReducer<
    SecretsStateType,
    PayloadAction<SecretToken['id']>
  >;
};

const secrets = createSlice<
  SecretsStateType,
  SecretsReducers,
  'secrets',
  never
>({
  initialState: defaultState,
  name: 'secrets',
  reducers: {
    secretsFetchStartedAction: (state) => ({
      ...state,
      isFetching: true,
    }),
    secretsGenerateStartedAction: (state) => ({
      ...state,
      isFetching: true,
    }),
    secretsRevokeStartedAction: (state) => ({
      ...state,
      isFetching: true,
    }),
    secretsFetchedAction: (state, { payload }) => ({
      ...state,
      isFetching: false,
      tokens: payload.map((token) => ({
        ...token,
        isVisible: false,
      })),
    }),
    secretsGeneratedAction: (state, { payload }) => ({
      ...state,
      isFetching: false,
      tokens: [
        ...state.tokens,
        {
          ...payload,
          isVisible: false,
        },
      ],
    }),
    secretsRevokedAction: (state, { payload }) => ({
      ...state,
      tokens: state.tokens.filter(({ id }) => id !== Number(payload)),
      isFetching: false,
    }),
    secretsVisibilityToggledAction: (state, { payload }) => ({
      ...state,
      tokens: state.tokens.map((token) => {
        if (token.id === Number(payload)) {
          return {
            ...token,
            isVisible: !token.isVisible,
          };
        }

        return token;
      }),
    }),
  },
});

export const {
  secretsFetchStartedAction,
  secretsGenerateStartedAction,
  secretsRevokeStartedAction,
  secretsFetchedAction,
  secretsGeneratedAction,
  secretsRevokedAction,
  secretsVisibilityToggledAction,
} = secrets.actions;

export default secrets.reducer;
